module.exports = __webpack_public_path__ + "img/collect-minimization.d0730f90.png";